import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Eyes_3 = ({ eyeColours, skinColours }) => {
  const colour0 = '#F15743';
  const colour1 = '#FFFEF0';
  const colour2 = '#F6E7D0';
  const colour3 = eyeColours.shadow;
  const colour4 = '#DF5656';
  const colour5 = skinColours.shadow;
  const colour6 = '#A4DEF9';

  return (
    <>
      <g>
        <g>
          <path
            fill={colour0}
            opacity={0.5}
            d="M438.8,378.9c-2.4-1.2-5.8-4.8-5.7-5.7c0-1,9.9-7.2,9.9-7.2L438.8,378.9z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M484.9,392.1c2.8-0.1,7.5-1.9,7.9-2.8c0.4-0.9-4.9-10.3-4.9-10.3L484.9,392.1z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M488,388.2c3.2-15.2-6.2-31-19.9-34c-13.8-2.9-27.6,7-30.8,22.1c-3.2,15.2,5.3,29.9,19.1,32.8
			C470.1,412.2,484.7,403.4,488,388.2z"
          />
          <path
            fill={colour1}
            d="M485.4,384.5c2.9-13.5-5-26.6-17.6-29.3c-12.6-2.7-25.2,6-28,19.5c-2.9,13.5,5.5,24.3,18.1,26.9
			C470.5,404.4,482.6,398,485.4,384.5z"
          />
          <path
            fill={colour2}
            d="M459.8,398.8c-12.6-2.7-20.8-14.1-18-27.6c0.5-2.2,1.2-4.2,2.1-6.1c-2,2.8-3.4,6-4.2,9.6
			c-2.9,13.5,5.4,24.9,18,27.6c10.7,2.3,21.1-2.5,25.8-12.2C478.3,397.5,469.2,400.8,459.8,398.8z"
          />
          <path
            fill={colour3}
            d="M471.7,384.6c1.3-5.9-2.2-11.6-7.7-12.7c-5.5-1.2-11,2.6-12.3,8.5c-1.3,5.9,2.2,11.6,7.7,12.7
			C464.9,394.2,470.4,390.4,471.7,384.6z"
          />
          <path
            fill={colour1}
            d="M468.4,394.4c2-0.9,3.1-2.8,2.4-4.4c-0.7-1.6-2.9-2.1-4.9-1.2c-2,0.9-3.1,2.8-2.4,4.4
			C464.2,394.7,466.4,395.3,468.4,394.4z"
          />
          <path
            fill={colour1}
            d="M470.6,385.7c0.4-0.9,0.1-1.8-0.5-2.1c-0.7-0.3-1.5,0.2-1.9,1c-0.4,0.9-0.1,1.8,0.5,2.1
			C469.4,387,470.2,386.5,470.6,385.7z"
          />
          <path
            fill={colour4}
            opacity={0.5}
            d="M492.8,389.2c-3.1-14.5-10.6-25.5-24.6-28.5c-12.1-2.6-29.7,1.3-35.1,12.3c0.7,2.4,3,3.7,3.6,4.4
			c9.2,1,42.7,8.9,50,14.3C488.7,391.7,492.5,390.1,492.8,389.2z"
          />
          <path
            fill={colour5}
            d="M434.9,370.8c4-5.9,38.1-14.2,57.3,15.5c0,0,1-27.9-22.5-32.9C442.2,347.5,434.9,370.8,434.9,370.8z"
          />
          <path
            fill={colour5}
            d="M435.1,367.9c-1.4,3.1-2,5.2-2,5.2c13.3-0.8,46.4,6.8,59.7,16.2c0,0,0.2-1.8,0.2-4.6
			C474.4,358.6,444.7,362.3,435.1,367.9z"
          />
        </g>
        <g>
          <path
            fill={colour0}
            opacity={0.5}
            d="M362.4,381.2c2.5-1.1,6-4.5,6-5.4c0-1-9.6-7.7-9.6-7.7L362.4,381.2z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M315.6,392.1c-2.8-0.2-7.4-2.3-7.7-3.2c-0.3-0.9,5.4-10.1,5.4-10.1L315.6,392.1z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M312.8,388c-2.5-15.3,7.7-30.7,21.6-32.9c13.9-2.2,27.2,8.4,29.7,23.7c2.5,15.3-6.8,29.6-20.7,31.8
			C329.5,412.9,315.3,403.4,312.8,388z"
          />
          <path
            fill={colour1}
            d="M315.5,384.6c-2.2-13.7,6.3-26.5,19-28.5c12.7-2.1,24.8,7.4,27,21.1c2.2,13.7-6.7,24.1-19.4,26.1
			C329.5,405.4,317.8,398.3,315.5,384.6z"
          />
          <path
            fill={colour2}
            d="M340.4,400.3c12.7-2.1,21.5-13.1,19.3-26.8c-0.4-2.2-1-4.3-1.8-6.3c1.8,2.9,3.1,6.2,3.7,9.9
			c2.2,13.7-6.6,24.8-19.3,26.8c-10.8,1.7-21-3.6-25.1-13.6C322.1,398,331,401.9,340.4,400.3z"
          />
          <path
            fill={colour3}
            d="M329.2,385.2c-1-5.9,2.8-11.4,8.4-12.3c5.6-0.9,10.9,3.2,11.8,9.1c1,5.9-2.8,11.4-8.4,12.3
			C335.5,395.2,330.2,391.1,329.2,385.2z"
          />
          <path
            fill={colour1}
            d="M343.7,388.3c1.2-1.8,3.4-2.5,4.8-1.6c1.4,1,1.6,3.2,0.3,5c-1.2,1.8-3.4,2.5-4.8,1.6
			C342.7,392.4,342.5,390.1,343.7,388.3z"
          />
          <path
            fill={colour1}
            d="M345.7,383.9c-0.3-0.9,0-1.8,0.7-2c0.7-0.2,1.5,0.3,1.8,1.1c0.3,0.9,0,1.8-0.7,2
			C346.8,385.3,346,384.8,345.7,383.9z"
          />
          <path
            fill={colour4}
            opacity={0.5}
            d="M307.9,388.7c3.8-14.3,11.9-24.9,26-27.2c12.2-2,29.6,2.8,34.5,14.1c-0.8,2.4-3.2,3.5-3.8,4.2
			c-9.3,0.5-43.1,6.7-50.6,11.7C311.9,391.4,308.2,389.7,307.9,388.7z"
          />
          <path
            fill={colour5}
            d="M366.7,373.3c-3.7-6.1-37.3-16.1-58,12.6c0,0,0.4-27.9,24.1-31.8C360.5,349.6,366.7,373.3,366.7,373.3z"
          />
          <path
            fill={colour5}
            d="M366.6,370.4c1.2,3.1,1.7,5.2,1.7,5.2c-12.6,3.2-46.7,4.4-60.5,13.1c0,0-0.1-1.8,0.1-4.6
			C327.9,359.2,357.3,364.4,366.6,370.4z"
          />
        </g>
        <path
          fill={colour0}
          opacity={0.5}
          d="M435.2,398.9c1.2,3.7,13.6,17.8,30.4,16.9c0,0-9.9,5.2-22.2-3C435.2,407.3,435.2,398.9,435.2,398.9z"
        />
        <path
          fill={colour0}
          opacity={0.5}
          d="M363.5,397.1c-0.9,3.7-9.3,17-20.6,18.8c0,0,7,2.1,14.7-5.4C363.6,404.7,363.5,397.1,363.5,397.1z"
        />
        <path
          fill={colour6}
          d="M318.7,397.5c2.4,3.9,6.3,11.5,2.4,11.9C317.5,409.7,318.7,397.5,318.7,397.5z"
        />
      </g>
    </>
  );
};

export default Eyes_3;
